export const getTrimmedUrl = (url: string) => {
    if (url && url.indexOf('?') >= 0) {
        return url.substring(0, url.indexOf('?'))
    }
    return url
}
